// Preferencias del reproductor que deben sobrevivir entre lecciones. Todo es
// best-effort: el modo privado o el storage deshabilitado nunca debe romper la
// reproducción. Nunca se guarda aquí ninguna URL ni token de streaming.
const PREFIX = 'academy:player:';

export const PREF = {
  rate: 'rate',
  captions: 'captions',
  muted: 'muted',
  quality: 'quality',
  audio: 'audio',
  autoNext: 'autonext',
  hintSeen: 'hint-seen',
} as const;

export type PrefKey = (typeof PREF)[keyof typeof PREF];

export function readPref(key: PrefKey): string | null {
  try {
    return localStorage.getItem(PREFIX + key);
  } catch {
    return null;
  }
}

export function writePref(key: PrefKey, value: string) {
  try {
    localStorage.setItem(PREFIX + key, value);
  } catch {
    // best-effort
  }
}

export function readBoolPref(key: PrefKey, fallback: boolean): boolean {
  const raw = readPref(key);
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return fallback;
}

export function readNumberPref(key: PrefKey, fallback: number): number {
  const raw = readPref(key);
  const parsed = raw === null ? NaN : Number.parseFloat(raw);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function formatPlayerTime(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return '00:00';
  }
  const total = Math.floor(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  const mm = minutes.toString().padStart(2, '0');
  const ss = secs.toString().padStart(2, '0');
  return hours > 0 ? `${hours.toString().padStart(2, '0')}:${mm}:${ss}` : `${mm}:${ss}`;
}
